import cn from "classnames";
import React from "react";

import styles from "./Initials.module.scss";

interface InitialsProps {
  initials: string;
  size: "small" | "large";
}

export const Initials: React.FC<InitialsProps> = ({ initials, size, ...rest }) => {
  return (
    <div className={cn(styles.initials, styles[size])} {...rest}>
      <span>{initials}</span>
    </div>
  );
};
